import { render, staticRenderFns } from "./RecruitmentDetail.vue?vue&type=template&id=a0bbc0ce&scoped=true"
import script from "./RecruitmentDetail.vue?vue&type=script&lang=js"
export * from "./RecruitmentDetail.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentDetail.vue?vue&type=style&index=0&id=a0bbc0ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bbc0ce",
  null
  
)

export default component.exports